'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SVGDeviconInline = require('../../_base/SVGDeviconInline');

var _SVGDeviconInline2 = _interopRequireDefault(_SVGDeviconInline);

var _CakephpPlainWordmark = require('./CakephpPlainWordmark.svg');

var _CakephpPlainWordmark2 = _interopRequireDefault(_CakephpPlainWordmark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** CakephpPlainWordmark */
function CakephpPlainWordmark(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className;

  return _react2.default.createElement(_SVGDeviconInline2.default, {
    className: 'CakephpPlainWordmark' + ' ' + className,
    iconSVG: _CakephpPlainWordmark2.default,
    width: width,
    height: height
  });
}

CakephpPlainWordmark.propTypes = {
  className: _propTypes2.default.string,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

exports.default = CakephpPlainWordmark;